<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Tue, 20 Feb 2024 08:02:30 Central Standard Time, Mexico City, Mexico
  - Copyright (c) 2024, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { inject, onMounted } from "vue"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faAddressBook, faClipboardList, faUsersCog } from "@fal"
import { generateNavigationName, generateCurrentString } from '@/Composables/useConvertString'
import '@/Composables/Icon/ProductionsStateIcon'

import { get } from "lodash"
import NavigationSimple from '@/Layouts/Grp/NavigationSimple.vue'
import NavigationGroup from "@/Layouts/Grp/NavigationGroup.vue"
import NavigationScope from "@/Layouts/Grp/NavigationScope.vue"
import NavigationHorizontal from "@/Layouts/Grp/NavigationHorizontal.vue"
import { layoutStructure } from "@/Composables/useLayoutStructure"
import { trans } from "laravel-vue-i18n"
import { usePage } from "@inertiajs/vue3"

library.add(faAddressBook, faClipboardList, faUsersCog)

const layout = inject('layout', layoutStructure)

onMounted(() => {
    if (localStorage.getItem('leftSideBar')) {
        // Read from local storage then store to Pinia
        layout.leftSidebar.show = JSON.parse(localStorage.getItem('leftSideBar') ?? '')
    }
})

console.log('ewqe', usePage().props.sidebar_navigation)
</script>

<template>
    <nav class="text-white isolate relative flex flex-grow flex-col pt-3 pb-4 px-2 h-full overflow-y-auto custom-hide-scrollbar flex-1 gap-y-1.5" aria-label="Sidebar">
        <template v-for="navigation in usePage().props.sidebar_navigation">
            
            <NavigationScope
                v-if="navigation.type === 'scope'"
                :navs="navigation.navigations"
                :icon="navigation.icon"
                :scope_label="navigation.scope_label"
                :root="navigation.root"
            />

            <NavigationSimple
                v-else
                :nav="navigation"
            />
            
        </template>
    </nav>
</template>
